// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"380":"27946d7d","427":"2b2255ff"}[chunkId] + ".chunk.js";
};